// extracted by mini-css-extract-plugin
export default {"root":"_2s33S","small":"WgZ25","normal":"_1XR-a"};